// Top-level editor tabs. The declaration order is the render order.
export enum EditorTab {
    General = "general",
    Chat = "chat",
    Voice = "voice",
    Avatar = "avatar",
    JsonViewer = "json"
}

export enum SnippetExperience {
    Chat = "chat",
    Voice = "voice",
    Avatar = "avatar"
}

export enum VoiceSnippetCloseAction {
    Minimize = "minimize",
    Chat = "chat",
    Avatar = "avatar"
}

export enum AvatarSnippetCloseAction {
    Minimize = "minimize",
    Chat = "chat",
    Voice = "voice"
}

export enum UISelectorType {
    booleanSelector = 'booleanSelector',
    switchSelector = 'switchSelector',
    colorSelector = 'colorSelector',
    defaultSelector = 'defaultSelector',
    dropDownSelector = 'dropDownSelector',
    integerSelector = 'integerSelector',
    percentageSelector = 'percentageSelector',
    rgbaSelector = 'rgbaSelector',
    reactSelector = 'reactSelector',
    localizationSelector = 'localizationSelector',
    themeSelector = 'themeSelector',
    avatarSelector = 'avatarSelector'
}
